import { useState, Fragment } from "react";
import { Tooltip, IconButton, Box, Collapse, Grid } from "@material-ui/core";
import Paper from "@material-ui/core/Paper";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TablePagination from "@material-ui/core/TablePagination";
import TableRow from "@material-ui/core/TableRow";
import KeyboardArrowDownIcon from '@material-ui/icons/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@material-ui/icons/KeyboardArrowUp';
import { makeStyles } from '@material-ui/core/styles';
import { useSelector, useDispatch } from "react-redux";
import { onLoadAnction, offLoadAction } from "../../../ducks/loadDuck";
import { obtenerCotizacionesAction, obtenerCotizacionesPaginaAction, obteneCotizacionesRegistrosAction, obtenerCotizacionPdfAction, aceptarCotizacionAgenteAction, declinarCotizacionAgenteAction, reenviarCotizacionAgenteAction, declinarCotizacionAgenteEditarAction, completarCotizacionProcesoAction } from "../../../ducks/cotizacioensDuck";
import { ToastMessage } from "../../../global/ToastMessage"
import { DialogMessage } from "../../../global/DialogMessage"
import GetAppIcon from '@material-ui/icons/GetApp'
import { FormatoFechaIso } from "../../../utils/FormatFecha";
import { formatDinero } from "../../../utils/formatDinero";
import BeenhereIcon from '@material-ui/icons/Beenhere'
import CancelIcon from '@material-ui/icons/Cancel';
import ReplayIcon from '@material-ui/icons/Replay';
import EditLocationIcon from '@material-ui/icons/EditLocation';
import OfflinePinIcon from '@material-ui/icons/OfflinePin';
import { catRoles } from "../../../constant/catRoles"
import FVigencia from "../FVigencia";
import { usePermiso } from "./../../../hooks/usePermiso"
import { catEstatusCotizacion } from "../../../constant/catEstatusCotizacion";
export const TClientesStyle = makeStyles((theme) => ({
    root: {
        width: '100%',
    },
    container: {
        maxHeight: "65vh",
    },
    ButtonContent: {
        display: "flex",
        flexFlow: "column wrap",
        justifyContent: "center",
        alignItems: "center",
    },
    section1: {
        margin: theme.spacing(1, 2),
    },
    section2: {
        margin: theme.spacing(1, 2),
    },
}))
const columns = [
    {
        id: "numero",
        minWidth: 50,
        align: "center",
        label: "#",
    },
    { id: "noCotizacion", minWidth: 10, align: "center", label: "Cotizacion" },
    {
        id: "NombreCliente",
        minWidth: 150,
        align: "center",
        label: "Nombre cliente",
    },
    { id: "email", minWidth: 10, align: "center", label: "Email" },
    { id: "telefono", minWidth: 50, align: "center", label: "Telefono" },
    { id: "vigencia", minWidth: 50, align: "center", label: "Vigencia" },
    {
        id: "paquete",
        minWidth: 50,
        align: "center",
        label: "Paquete",
    },
    { id: "mod", minWidth: 30, align: "center", label: "" },
    { id: "Accion", minWidth: 10, align: "center", label: "" },
]
const useRowStyles = makeStyles({
    root: {
        '& > *': {
            borderBottom: 'unset',
        },
    },

})
function Row(props) {
    const {
        row,
        index
    } = props
    const [permitido] = usePermiso({ location: "FK_COTIZACIONES_ADMIN_VIENGENCIA", initialValue: false })

    const dispatch = useDispatch()
    const [open, setOpen] = useState(false)
    const classes = useRowStyles()
    const { profile } = useSelector(store => store.logeo)

    const onAceptarCotizacion = ({ id }) => {
        DialogMessage.fire({
            title: `¿Estas seguro de aceptar la cotizacion con numero: #${id}?`,
            text: "Este cambio no se puede deshacer",
            showCancelButton: true,
            confirmButtonText: "Aceptar",
            cancelButtonText: "Cancelar",
        }).then((result) => {
            if (result.isConfirmed) {
                dispatch(onLoadAnction({ message: "Procesando" }))
                dispatch(aceptarCotizacionAgenteAction({ IdCotizacion: id })).then((Response) => {
                    dispatch(offLoadAction())
                    if (Response.status === 500) {
                        ToastMessage.fire({
                            icon: "error",
                            title: "Ha ocurrido un error, por favor inténtelo de nuevo más tarde",
                        })
                        return null
                    }
                    if (Response.status === 400) {
                        ToastMessage.fire({
                            icon: "warning",
                            title: Response.Message,
                        })
                        return null
                    }
                    dispatch(onLoadAnction({ message: "" }))
                    dispatch(obtenerCotizacionesAction()).then(Response => {
                        dispatch(offLoadAction())
                    })
                    ToastMessage.fire({
                        icon: "success",
                        title: "Ingreso Correcto",
                    })
                })
            }
        })
    }
    const onDeclinarCotizacion = ({ id }) => {
        DialogMessage.fire({
            title: `¿Estas seguro de declinar la cotizacion con numero: #${id}?`,
            text: "Este cambio no se puede deshacer",
            showCancelButton: true,
            confirmButtonText: "Aceptar",
            cancelButtonText: "Cancelar",
        }).then((result) => {
            if (result.isConfirmed) {
                dispatch(onLoadAnction({ message: "Procesando" }))
                dispatch(declinarCotizacionAgenteAction({ IdCotizacion: id })).then((Response) => {
                    dispatch(offLoadAction())
                    if (Response.status === 500) {
                        ToastMessage.fire({
                            icon: "error",
                            title: "Ha ocurrido un error, por favor inténtelo de nuevo más tarde",
                        })
                        return null
                    }
                    if (Response.status === 400) {
                        ToastMessage.fire({
                            icon: "warning",
                            title: Response.Message,
                        })
                        return null
                    }
                    dispatch(onLoadAnction({ message: "" }))
                    dispatch(obtenerCotizacionesAction()).then(Response => {
                        dispatch(offLoadAction())
                    })
                    ToastMessage.fire({
                        icon: "success",
                        title: "Ingreso Correcto",
                    })
                })
            }
        })
    }
    const onDeclinarEditarCotizacion = ({ id }) => {
        DialogMessage.fire({
            title: `¿Estas seguro de declinar la cotizacion con numero: #${id} para su modificación?`,
            text: "Este cambio no se puede deshacer",
            showCancelButton: true,
            confirmButtonText: "Aceptar",
            cancelButtonText: "Cancelar",
        }).then((result) => {
            if (result.isConfirmed) {
                dispatch(onLoadAnction({ message: "Procesando" }))
                dispatch(declinarCotizacionAgenteEditarAction({ IdCotizacion: id })).then((Response) => {
                    dispatch(offLoadAction())
                    if (Response.status === 500) {
                        ToastMessage.fire({
                            icon: "error",
                            title: "Ha ocurrido un error, por favor inténtelo de nuevo más tarde",
                        })
                        return null
                    }
                    if (Response.status === 400) {
                        ToastMessage.fire({
                            icon: "warning",
                            title: Response.Message,
                        })
                        return null
                    }
                    dispatch(onLoadAnction({ message: "" }))
                    dispatch(obtenerCotizacionesAction()).then(Response => {
                        dispatch(offLoadAction())

                    })
                    ToastMessage.fire({
                        icon: "success",
                        title: "Ingreso Correcto",
                    })
                })
            }
        })
    }
    const onReenviarCotizacion = ({ id }) => {
        DialogMessage.fire({
            title: `¿Estas seguro de reenviar un nuevo contrato de la cotizacion con numero: #${id}?`,
            text: "Este cambio no se puede deshacer",
            showCancelButton: true,
            confirmButtonText: "Aceptar",
            cancelButtonText: "Cancelar",
        }).then((result) => {
            if (result.isConfirmed) {
                dispatch(onLoadAnction({ message: "Procesando" }))
                dispatch(reenviarCotizacionAgenteAction({ IdCotizacion: id })).then((Response) => {
                    dispatch(offLoadAction())
                    if (Response.status === 500) {
                        ToastMessage.fire({
                            icon: "error",
                            title: "Ha ocurrido un error, por favor inténtelo de nuevo más tarde",
                        })
                        return null
                    }
                    if (Response.status === 400) {
                        ToastMessage.fire({
                            icon: "warning",
                            title: Response.Message,
                        })
                        return null
                    }
                    dispatch(onLoadAnction({ message: "" }))
                    dispatch(obtenerCotizacionesAction()).then(Response => {
                        dispatch(offLoadAction())

                    })
                    ToastMessage.fire({
                        icon: "success",
                        title: "Ingreso Correcto",
                    })
                })
            }
        })
    }
    const onTerminarProcesoCotizacion = ({ id }) => {
        DialogMessage.fire({
            title: `¿Estas seguro de teminar con el proceso de contratacion de la cotizacion con numero: #${id}?`,
            text: "Este cambio no se puede deshacer",
            showCancelButton: true,
            confirmButtonText: "Aceptar",
            cancelButtonText: "Cancelar",
        }).then((result) => {
            if (result.isConfirmed) {
                dispatch(onLoadAnction({ message: "Procesando" }))
                dispatch(completarCotizacionProcesoAction({ IdCotizacion: id })).then((Response) => {

                    if (Response.status === 500) {
                        ToastMessage.fire({
                            icon: "error",
                            title: "Ha ocurrido un error, por favor inténtelo de nuevo más tarde",
                        })
                        return null
                    }
                    if (Response.status === 400) {
                        ToastMessage.fire({
                            icon: "warning",
                            title: Response.Message,
                        })
                        return null
                    }
                    dispatch(obtenerCotizacionesAction()).then(Response => {
                        dispatch(offLoadAction())
                    })
                    ToastMessage.fire({
                        icon: "success",
                        title: "Ingreso Correcto",
                    })
                })
            }
        })
    }
    const handleDowloadCotizacioon = ({ id }) => {
        dispatch(onLoadAnction({ message: "" }))
        dispatch(obtenerCotizacionPdfAction({ IdCotizacion: id })).then(Response => {
            dispatch(offLoadAction())
            if (Response?.status === 500) {
                ToastMessage.fire({
                    icon: "warning",
                    title: "Se produjo un error inesperado. Inténtelo de nuevo más tarde",
                });
                return null
            }
            if (Response?.status === 400) {
                ToastMessage.fire({
                    icon: "warning",
                    title: Response.Message,
                });
                return null
            }
            const downloadUrl = window.URL.createObjectURL(new Blob([Response.data], { type: Response.contentType }));
            const link = document.createElement('a');
            link.href = downloadUrl;
            link.target = "_blank"
            // link.download = `Cotización-${id}-${new Date().toString()}`;
            document.body.appendChild(link);
            link.click();
            link.remove();
            dispatch(obtenerCotizacionesAction())
            ToastMessage.fire({
                icon: "success",
                title: "Archivo descargado",
            });
        })
    }
    return (
        <Fragment>
            <TableRow className={classes.root} hover>
                <TableCell align="center">{index}</TableCell>
                <TableCell align="center">
                    {row?.IdCotizacion}
                </TableCell>
                <TableCell align="center">{row?.Cliente?.Nombre}</TableCell>
                <TableCell align="center">
                    {row?.Cliente?.EMail}
                </TableCell>
                <TableCell align="center">
                    {row?.Cliente?.Telefono}
                </TableCell>
                <TableCell align="center">
                    {FormatoFechaIso({ date: row?.FechaExpiracion, formato: "dd/MM/yyyy" })}
                </TableCell>
                <TableCell align="center">{row.NombrePaquete}</TableCell>
                <TableCell align="center">
                    <div style={{ display: "flex", justifyContent: "flex-end", alignItems: "center" }}>
                        <Tooltip title="Descargar">
                            <IconButton aria-label="Descargar" onClick={() => handleDowloadCotizacioon({ id: row.IdCotizacion })}>
                                <GetAppIcon color="secondary" />
                            </IconButton>
                        </Tooltip>
                        {
                            (row?.CatEstatusCotizacion?.IdCatEstatusCotizacion < catEstatusCotizacion.ACEPTADA_AGENTE) &&
                            <Tooltip title="Aprobar cotizacion">
                                <IconButton
                                    aria-label="aceptarCotizacion"
                                    onClick={() => onAceptarCotizacion({ id: row.IdCotizacion })}
                                    disabled={(row?.CatEstatusCotizacion?.IdCatEstatusCotizacion >= catEstatusCotizacion.ACEPTADA_AGENTE) ? true : false}
                                    color="secondary"
                                >
                                    <BeenhereIcon />
                                </IconButton>
                            </Tooltip>
                        }
                        {
                            (row?.CatEstatusCotizacion?.IdCatEstatusCotizacion < catEstatusCotizacion.ACEPTADA_AGENTE) &&
                            <Tooltip title="Declinar para editar">
                                <IconButton
                                    aria-label="aceptarCotizacion"
                                    onClick={() => onDeclinarEditarCotizacion({ id: row.IdCotizacion })}
                                    disabled={(row?.CatEstatusCotizacion?.IdCatEstatusCotizacion >= catEstatusCotizacion.ACEPTADA_AGENTE) ? true : false}
                                    color="primary"
                                >
                                    <EditLocationIcon />
                                </IconButton>
                            </Tooltip>
                        }
                        {
                            (row?.CatEstatusCotizacion?.IdCatEstatusCotizacion !== catEstatusCotizacion.RECHAZADA
                                && row?.CatEstatusCotizacion?.IdCatEstatusCotizacion !== catEstatusCotizacion.CERRADO_GANADO) &&
                            <Tooltip title="Declinar cotizacion">
                                <IconButton
                                    aria-label="aceptarCotizacion"
                                    onClick={() => onDeclinarCotizacion({ id: row.IdCotizacion })}
                                    disabled={(row?.CatEstatusCotizacion?.IdCatEstatusCotizacion === catEstatusCotizacion.RECHAZADA || row?.CatEstatusCotizacion?.IdCatEstatusCotizacion === catEstatusCotizacion.CERRADO_GANADO) ? true : false}
                                    color="secondary"
                                >
                                    <CancelIcon color="error" />
                                </IconButton>
                            </Tooltip>
                        }
                        {
                            (profile.Rol?.Id === catRoles.DEVELOPER ||
                                profile.Rol?.Id === catRoles.ADMINISTRADOR) &&
                            <Tooltip title="reenviar contrato">
                                <IconButton
                                    aria-label="aceptarCotizacion"
                                    onClick={() => onReenviarCotizacion({ id: row.IdCotizacion })}
                                    disabled={(row?.CatEstatusCotizacion?.IdCatEstatusCotizacion === catEstatusCotizacion.CONTRATO_EXPIRADO) ? false : true}
                                    color="primary"
                                >
                                    <ReplayIcon />
                                </IconButton>
                            </Tooltip>
                        }
                        {
                            (profile.Rol?.Id === catRoles.DEVELOPER ||
                                profile.Rol?.Id === catRoles.ADMINISTRADOR) &&
                            <Tooltip title="Teminar proceso de contratación">
                                <IconButton
                                    aria-label="aceptarCotizacion"
                                    onClick={() => onTerminarProcesoCotizacion({ id: row.IdCotizacion })}
                                    disabled={(row?.CatEstatusCotizacion?.IdCatEstatusCotizacion === catEstatusCotizacion.CONTRATO_ACEPTADO) ? false : true}
                                    color="primary"
                                >
                                    <OfflinePinIcon />
                                </IconButton>
                            </Tooltip>
                        }
                        {
                            (profile.Rol?.Id === catRoles.DEVELOPER ||
                                profile.Rol?.Id === catRoles.ADMINISTRADOR ||
                                permitido) &&
                            <FVigencia idCotizacion={row.IdCotizacion} />
                        }
                    </div>
                </TableCell>
                <TableCell>
                    <IconButton aria-label="expand row" size="small" onClick={() => setOpen(!open)}>
                        {open ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
                    </IconButton>
                </TableCell>
            </TableRow>
            <TableRow>
                <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={8}>
                    <Collapse in={open} timeout="auto" unmountOnExit>
                        <Box margin={1}>
                            <Grid container>
                                <Grid item xs={3}>
                                    <h5>Paquete: {row?.NombrePaquete}</h5>
                                    <p>Clave paquete: {row?.ClavePaquete}</p>
                                    <p>Fecha de salida: {FormatoFechaIso({ date: row?.FechaSalida, formato: "dd/MM/yyyy" })}</p>
                                    <p>Adultos: {row?.Adultos}</p>
                                    <p>Menores: {row?.Menores}</p>
                                    <p>Infantes: {row?.Infantes}</p>
                                </Grid>
                                <Grid item xs={3}>
                                    <p>Estatus cotizacion: {row?.CatEstatusCotizacion?.Descripcion}</p>
                                    <p>Agente: {`${row?.Agente?.Nombre} ${row?.Agente?.Apellido_Paterno} ${row?.Agente?.Apellido_Materno}`}</p>
                                    <p>Correo: {`${row?.Agente?.eMail}`}</p>
                                </Grid>
                                <Grid item xs={3}>
                                    <p>Monto paquete: {formatDinero(row?.MontoPaquete)} {row?.Moneda?.Clave}</p>
                                    {
                                        row?.lFormatoPago?.map((pago, item) => {
                                            return (
                                                <p key={pago?.IdFormatoPago}>
                                                    <b>Tipo:</b> {pago?.CatTipoPago?.Nombre} <br />
                                                    <b>Cantidad de pagos:</b> {pago?.NumeroPagos} <br />
                                                    <b>Banco</b>
                                                    {
                                                        (pago?.BancoFormatoPago) ?
                                                            ` ${pago?.BancoFormatoPago?.Banco?.Nombre}`
                                                            : " No Aplica"
                                                    }
                                                    <br />

                                                </p>
                                            )
                                        })
                                    }
                                </Grid>
                                <Grid item xs={3}>
                                    {
                                        row?.lContizacionSuplemento?.map((suplemento, item) => {
                                            return (
                                                <p key={suplemento?.IdCotizacionSuplementos}>
                                                    <b>Tipo:</b> {suplemento?.TipoSuplemento} <br />
                                                    <b>Precio:</b> {formatDinero(suplemento?.Precio)} <br />
                                                    {suplemento?.Nombre}
                                                </p>
                                            )
                                        })
                                    }
                                </Grid>
                            </Grid>
                        </Box>
                    </Collapse>
                </TableCell>
            </TableRow>
        </Fragment>
    );
}

export const TClientes = () => {
    const { cotizaciones, pagina, registroPagina, total } = useSelector(store => store.cotizaciones)
    const dispatch = useDispatch()
    const classes = TClientesStyle();
    const rows = cotizaciones
    const handleChangePage = (event, newPage) => {
        dispatch(onLoadAnction({ message: "" }))
        dispatch(obtenerCotizacionesPaginaAction({ Pagina: newPage })).then(Response => {
            dispatch(offLoadAction())
        })
    }
    const handleChangeRowsPerPage = (event) => {
        dispatch(onLoadAnction({ message: "" }))
        dispatch(obteneCotizacionesRegistrosAction({ Registros: +event.target.value })).then(Response => {
            dispatch(offLoadAction())
        })
    }
    return (
        <Paper className={classes.root}>
            <TableContainer className={classes.container}>
                <Table stickyHeader aria-label="sticky table">
                    <TableHead>
                        <TableRow>
                            {columns.map((column) => (
                                <TableCell
                                    key={column.id}
                                    align={column.align}
                                    style={{ minWidth: column.minWidth }}
                                >
                                    {column.label}
                                </TableCell>
                            ))}
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {
                            rows
                                .map((row, index) => {
                                    return (
                                        <Row
                                            index={index + 1}
                                            key={row.IdCliente}
                                            row={row}
                                        />
                                    );
                                })}
                    </TableBody>
                </Table>
            </TableContainer>
            <TablePagination
                rowsPerPageOptions={[10, 25, 100]}
                component="div"
                count={total}
                rowsPerPage={registroPagina}
                page={pagina}
                onPageChange={handleChangePage}
                onRowsPerPageChange={handleChangeRowsPerPage}
            />
        </Paper>
    );
}
export default TClientes

